module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDoelstellingenCA526C.b01a23d2.png";